import { c as _c } from "react/compiler-runtime";
import { Button } from "@website/ui/button";
import { LazyImage } from "@website/ui/lazy-image";
import emptyResult from "@website/widget/reserve-comment-popup-scroll/reserve-comment-filter/assets/empty-result.png";
import { ReserveCommentFilterEmptyResultTypes } from "@website/widget/reserve-comment-popup-scroll/reserve-comment-filter/reserve-comment-filter-empty-result/reserve-comment-filter-empty-result.types";
import omit from "lodash-es/omit";
import { useRouter } from "next/router";
export const ReserveCommentsFilterEmptyResult = t0 => {
  const $ = _c(5);
  const {
    onLoadFilter
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LazyImage src={emptyResult?.src} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col items-center gap-2"><div className="text-subtitle-1">نتیجه‌ای یافت نشد.</div><div className="text-caption text-on-surface-medium-emphasis">متاسفانه در حال حاضر نظری متناسب با فیلتر های انتخابی شما وجود ندارد.</div></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onLoadFilter || $[3] !== router) {
    t3 = <div className="flex flex-col items-center justify-center gap-6">{t1}{t2}<Button color="secondary" onClick={() => {
        if (onLoadFilter) {
          onLoadFilter({
            attitude: "all"
          });
        }
        router.push({
          pathname: router.pathname,
          query: {
            ...omit(router?.query, Object.keys(router?.query).filter(_temp))
          }
        }, undefined, {
          shallow: true,
          scroll: false
        });
      }} variant="outline">نمایش همه نظرات</Button></div>;
    $[2] = onLoadFilter;
    $[3] = router;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
function _temp(item) {
  return item.startsWith("filter_");
}